// These are our DDD Entity names in the Coupons project.
export enum CompanyCreationDomain {
  CompanyCreation = 'CompanyCreation',
  SelfEmploymentCreation = 'SelfEmploymentCreation',
  SingleMemberFirmCreation = 'SingleMemberFirmCreation',
  Backoffice = 'Backoffice',
  Lawyer = 'Lawyer',
  PhoneCallRequest = 'PhoneCallRequest',
  Coupon = 'Coupon',
  PricingPackage = 'PricingPackage',
  PricingFeature = 'PricingFeature',
  PricingOffer = 'PricingOffer',
}

// These are DDD Entity plural names for REST controllers
export enum CompanyCreationsDomainPlural {
  companyCreations = 'companyCreations',
  selfEmploymentCreation = 'selfEmploymentCreations',
  backoffice = 'backoffice',
  lawyers = 'lawyers',
  coupons = 'coupons',
  pricingPackages = 'pricing-packages',
  singleMemberFirmCreation = 'single-member-firm-creations',
}

export const BupaKKVCompanyCreationModuleName = 'bupa-kkv-company-creation';
